"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import { GameControlsExitFullscreen } from "@workspace/frontend-ui";
import type { FC } from "react";

const FullscreenExitOverlay: FC = () => {
  const { isFullscreen, toggleFullscreen, t } = useGamePageData();

  if (!isFullscreen) return null;

  return (
    <div className="z-[999] bg-[linear-gradient(180deg,rgba(0,0,0,0.56)_-96.43%,rgba(0,0,0,0.00)_100%)] flex px-6 justify-end w-full fixed top-0 left-0 text-right">
      <button
        type="button"
        aria-label={t("game.controls.fullscreen.exit", "Exit fullscreen")}
        onClick={toggleFullscreen}
        className="rounded-b-xl bg-black/[0.04] backdrop-blur-md flex w-9 h-9 p-2 justify-center items-center gap-2.5 shrink-0"
      >
        <GameControlsExitFullscreen />
      </button>
    </div>
  );
};

export default FullscreenExitOverlay;
